import { useState, useEffect } from "react";
import { styled } from "@mui/material/styles";

import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";

import PropTypes from "prop-types";
import { useSelector } from "react-redux";

import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

const LightTooltip = styled(({ className, ...props }) => (
    <Tooltip
        {...props}
        classes={{ popper: className }}
    />
))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: theme.palette.common.white,
        color: "rgba(0, 0, 0, 0.87)",
        //   boxShadow: theme.shadows[1],
        fontSize: 11,
    },
}));

function SampleSizeNew({ productsSecondaryData = [], pageName = null, sampleInfo = {}, productData = {}, alwaysShowIcon = false }) {
    const [sampleSize, setSampleSize] = useState(0);
    const [tooltipMessage, setTooltipMessage] = useState("");
    const [color, setColor] = useState("#000000");

    const productCategoryData = useSelector((state) => state.settingsStore.productCategory);

    const isHairCare = process.env?.REACT_APP_HAIR_CARE?.toLowerCase() === productCategoryData?.label?.toLowerCase();
    const isSkinCare = process.env?.REACT_APP_SKIN_CARE?.toLowerCase() === productCategoryData?.label?.toLowerCase();
    const isBeautyAndWellBeing = isHairCare || isSkinCare;

    useEffect(() => {
        let _sampleSize;
        if (pageName === "correlation") {
            const productCode = productData.title.split(" ").join("_");
            const coreDataId = productData.coreDataId;
            _sampleSize = sampleInfo.find((item) => item.title.split(" ").join("_") === productCode && item.coreDataId === coreDataId)?.sampleSize;
        } else {
            _sampleSize = productData.sampleSize;
        }
        let _color = "#000000";
        let _tooltipMessage = "";

        // Condition for Beauty & Wellbeing (Hair Care and Skin Care) with n < 90
        if (isBeautyAndWellBeing && _sampleSize < 90) {
            _color = "#FF0000"; // Red color for sample size
            _tooltipMessage = "Sample Size is below 90 (Qualitative Data)"; // Updated message for Beauty & Wellbeing
        } else if (_sampleSize <= 30) {
            _color = "#FF0000";
            _tooltipMessage = "Sample size is below 30";
        } else if (_sampleSize > 30 && _sampleSize <= 75) {
            _color = "#ffa500";
            _tooltipMessage = "The sample size falls between 31 and 75";
        }

        setSampleSize(_sampleSize);
        setTooltipMessage(_tooltipMessage);
        setColor(_color);
    }, [sampleInfo, pageName, productData, productsSecondaryData, isBeautyAndWellBeing]);

    const shouldShowIcon = alwaysShowIcon || (isBeautyAndWellBeing ? sampleSize < 90 : sampleSize <= 75);

    return (
        <span
            style={{
                fontSize: "12px",
                textAlign: "center",
                fontWeight: "bold",
            }}
        >
            <span style={{ color: color }}>(n={sampleSize})</span>
            <sup>
                {shouldShowIcon ? (
                    <LightTooltip
                        title={tooltipMessage || `Sample size is ${sampleSize}`}
                        placement="right"
                    >
                        <InfoOutlinedIcon
                            style={{
                                fontSize: "11px",
                                color: color,
                                cursor: "pointer",
                            }}
                        />
                    </LightTooltip>
                ) : null}
            </sup>
        </span>
    );
}
SampleSizeNew.propTypes = {
    productsSecondaryData: PropTypes.array,
    pageName: PropTypes.string,
    sampleInfo: PropTypes.object,
    productData: PropTypes.object,
    alwaysShowIcon: PropTypes.bool,
};
export default SampleSizeNew;
